const Years: number[] = [];
for (let year = 2011; year <= 2026; year++) {
    Years.push(year);
}

export default Years

